var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-table__cell-value with-description-cell" },
    [
      _vm.descriptionModel && _vm.descriptionModel.hasDescription
        ? [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("showDescription", _vm.descriptionModel)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.value))]
            ),
          ]
        : [_vm._v(" " + _vm._s(_vm.value) + " ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }